import React, { FC, useEffect }                                          from 'react';
import { ScriptLoaderWithVisualBug, VendorLoaderProps }                  from './ScriptLoaderWithVisualBug';
import { useAuth0 }                                                      from '@auth0/auth0-react';
import { useLocation }                                                   from 'react-router';
import { ENVIRONMENT_IS_PRODUCTION, ENVIRONMENT_IS_DEVELOPMENT, PRODUCT_VERSION, ENVIRONMENT_LABEL } from '../../../../constants/SystemEnums';

const defaultProps: VendorLoaderProps = {
	id: null
}

enum INTERCOM_ENV_IDS {
	TEST = 'mxiuek6m', 
	PROD = 'yx43miwd',
}

const Intercom: FC<VendorLoaderProps> = ( { id, ...props } ) => {
	
	let { isLoading } = useAuth0(),
	    location      = useLocation();
	
	let appID = ( ENVIRONMENT_IS_PRODUCTION )
	            ? INTERCOM_ENV_IDS.PROD
	            : INTERCOM_ENV_IDS.TEST;
	
	useEffect( () => {}, [ isLoading ] )
	
	useEffect( () => {
		
		//@ts-ignore
		if( !isLoading && window.Intercom && !ENVIRONMENT_IS_DEVELOPMENT ){
			try{
				
				//@ts-ignore
				window.intercomSettings = {
					horizontal_padding: 20,
					vertical_padding:   50
				};
				
				//@ts-ignore
				window.Intercom( "boot", {
					api_base:            "https://api-iam.intercom.io",
					app_id:              appID,
					product_version:     PRODUCT_VERSION,
					product_environment: ENVIRONMENT_LABEL
				} );
				
				
				
			} catch( e ) {
				
			
			}
		}
		
	}, [ location ] )
	
	const initScript = () => {
		const w = window;
		
		//@ts-ignore
		const ic = w.Intercom;
		
		if( typeof ic === "function" ){
			
			ic( 'reattach_activator' );
			
			//@ts-ignore
			ic( 'update', w.intercomSettings );
		} else {
			
			var d = document;
			
			//@ts-ignore
			var i = function(){i.c( arguments );};
			
			//@ts-ignore
			i.q = [];
			
			//@ts-ignore
			i.c = function( args ){i.q.push( args );};
			
			//@ts-ignore
			w.Intercom = i;
			
			var l = function(){
				var s   = d.createElement( 'script' );
				s.type  = 'text/javascript';
				s.async = true;
				s.src   = `https://widget.intercom.io/widget/${ appID }`;
				var x   = d.getElementsByTagName( 'script' )[ 0 ];
				x.parentNode.insertBefore( s, x );
			};
			
			if( document.readyState === 'complete' ){
				l();
				//@ts-ignore
			} else if( w.attachEvent ){
				//@ts-ignore
				w.attachEvent( 'onload', l );
			} else {
				w.addEventListener( 'load', l, false );
			}
		}
		
	};
	
	return isLoading ? null : ( id ? <ScriptLoaderWithVisualBug onLoad={ initScript } { ...props }/> : null );
}

Intercom.defaultProps = defaultProps;

export { Intercom }
